import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_68efc40c";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_68efc40c" };
/** script content **/
require("./confirm-button-group.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex68efc40c%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fmodal%2Fconfirm-button-group%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_68efc40c"],
    ctorType: "component",
    outputPath: "components/index68efc40c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'cube-button': getComponent(require("../../button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")), 'cube-button-group': getComponent(require("../../button-group/index.mpx?isComponent&outputPath=components%2Findexb32f512a%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
